export var isImage = function (fileType) {
    return (!!fileType &&
        (fileType.indexOf('image/') > -1 || fileType.indexOf('video/') > -1));
};
//# sourceMappingURL=is-image.js.map